import { render, staticRenderFns } from "./stk_othin.vue?vue&type=template&id=15976fdb&scoped=true&"
import script from "./stk_othin.vue?vue&type=script&lang=js&"
export * from "./stk_othin.vue?vue&type=script&lang=js&"
import style0 from "./stk_othin.vue?vue&type=style&index=0&id=15976fdb&scoped=true&lang=less&"
import style1 from "./stk_othin.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15976fdb",
  null
  
)

export default component.exports